import {shape, array, arrayOf, string, bool} from 'prop-types';

const FeedingGuidelinesLineChartType = {
};

export default FeedingGuidelinesLineChartType;
